import React from 'react';
import { AccordionItem } from './AccordionItem';
import styles from './Accordion.module.scss';

export const Accordion = ({ data }) => {
  return (
    <div className={styles.accordionContainer}>
      {data.map(item => (
        <AccordionItem item={item} key={item.title} />
      ))}
    </div>
  );
};
